import { render } from "./EmptyFavoriteList.vue?vue&type=template&id=19329d62&scoped=true"
import script from "./EmptyFavoriteList.vue?vue&type=script&lang=js"
export * from "./EmptyFavoriteList.vue?vue&type=script&lang=js"

import "./EmptyFavoriteList.vue?vue&type=style&index=0&id=19329d62&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19329d62"]])

export default __exports__